import {
	disablePinchZoom,
	disableKeyboardZoom,
	disableMouseWheelZoom,
} from '../lib/helpers';
// ---- parent imports ----

import useEventListener from './useEventListener';
// ---- local imports ----

export default function useDisableBrowserZoom() {
	useEventListener(window, 'touchmove', disablePinchZoom);
	useEventListener(window, 'keydown', disableKeyboardZoom);
	useEventListener(window, 'wheel', disableMouseWheelZoom, {
		passive: false
	});
}
